// 引入vue-router
import VueRouter from "vue-router";

// 引入页面组件
// 旧教育业务（Home/Activity/My/Login/Register + subpages + pages_admin 那一整套）
// 已随基座清理删除，后台只剩 OPC 控制台一个页面。
import OpcConsole from "../components/subpages_admin/OpcConsole.vue";

const router = new VueRouter({
  routes: [
    // 根路径进控制台。控制台自己没有 token 时会渲染登录表单，
    // 所以这里不需要单独的路由守卫，也不需要 /login 页面。
    {
      path: "/",
      redirect: "/opc-admin",
    },
    {
      name: "opcConsole",
      path: "/opc-admin",
      component: OpcConsole,
      meta: { title: "轻创 OPC 运营后台" },
    },
    // 旧书签/旧链接一律回控制台，避免落到空白页
    {
      path: "*",
      redirect: "/opc-admin",
    },
  ],
});

// 获取原型对象push函数
const originalPush = VueRouter.prototype.push;

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

router.afterEach((to) => {
  document.title = to.meta.title;
});

export default router;
